import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { AccesToken } from '@easy-lib/modules/authentication/models/auth.model';

import {
	AccountActivityItemDto,
	AccountUserInfo,
	DeviceTypeEnum,
	UserInfoDto
} from '@easy-lib/modules/account-activity/models/accountDto';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserService } from '@easy-lib/modules/shared/services/user.service';
import { BaseService } from '@easy-lib/modules/shared/services/Base/base.service';
import { UserDeviceService } from '@easy-lib/modules/shared/services/user-device.service';

@Injectable({
	providedIn: 'root'
})
export class AccountService extends BaseService {
	get deviceType(): DeviceTypeEnum {
		return this.userDeviceService.deviceType;
	}

	// bourseCode: string = "";

	public userAccountInfo = new BehaviorSubject<UserInfoDto>(null);
	public userAccountInfo$ = this.userAccountInfo.asObservable();
	userAccountInfoFiltered$ = this.userAccountInfo$.pipe(first(res => res?.customerIsin?.length > 0));

	_accountActivities;
	get accountActivities(): AccountActivityItemDto[] {
		return this._accountActivities;
	}

	set accountActivities(a: AccountActivityItemDto[]) {
		this._accountActivities = a;
	}

	public accountActivitySeenSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	public accountActivitySeen$: Observable<boolean> = this.accountActivitySeenSub.asObservable();

	private userDeviceService = inject(UserDeviceService);
	private userService = inject(UserService);
	private deviceDetectorService = inject(DeviceDetectorService);

	removeSession(ids: string[]) {
		// this.localStorage.setItem(this.jwtKey, JSON.stringify(this._user));
		return this.httpService.post<any>(`${this.mtsPath + this.apiUrls.easy}account/remove-sessions`, {
			body: {
				ids
			}
		});
	}

	setUserAccountInfo(accessToken: AccesToken): void {
		if (this.userService.isGuestUser) this.userAccountInfo.next({ customerTitle: 'کاربر میهمان' });
		else if (accessToken)
			this.userAccountInfo.next({
				customerTitle: accessToken?.display_name ?? '',
				customerIsin: accessToken?.customer_isin ?? '',
				email: accessToken?.email ?? '',
				nationalId: accessToken?.national_id ?? '',
				phoneNumber: accessToken?.phone_number ?? '',
				firstName: accessToken?.firstname ?? '',
				lastName: accessToken?.lastname ?? '',
				bourseCode: accessToken?.bourse_code ?? null,
				userFullName: accessToken?.display_name ?? '',
				loginDate: new Date()
			} as UserInfoDto);
	}

	getUserAccountActivities(): Observable<AccountActivityItemDto[]> {
		if (this.accountActivities) return of(this.accountActivities);
		return this.httpService
			.get<AccountActivityItemDto[]>(`${this.mtsPath + this.apiUrls.easy}UserActivity/user-activity`)
			.pipe(
				tap(data => {
					data.map(a => {
						this.deviceDetectorService.setDeviceInfo(a.userAgent);
						a.deviceType = this.deviceDetectorService.isMobile()
							? DeviceTypeEnum.Mobile
							: DeviceTypeEnum.Desktop;
						a.isExpired = !a.logoutDate && new Date(Date.now()) > new Date(a.expiryDate);
						a.deviceInfo = this.deviceDetectorService.getDeviceInfo();
					});
					this.accountActivities = data;
				})
			);
	}

	getUserInfo(): void {
		if (this.userAccountInfo?.value?.bourseCode) return;
		this.httpService
			.get<AccountUserInfo>(`${this.mtsPath + this.apiUrls.easy}account/user-info`)
			.pipe(
				tap(data => {
					this.userAccountInfo.next({ ...this.userAccountInfo.value, bourseCode: data.bourseCode });
				})
			)
			.subscribe();
	}

	accountActivitySeen(state: boolean) {
		this.accountActivitySeenSub.next(state);
	}

	isIndUser(customerIsin: string) {
		return customerIsin.endsWith('1129');
	}
}
